import { useQuery } from '@tanstack/react-query'
import { getApiClient } from '@/lib/api'
import type { SearchRequest, SearchResponse, SearchStrategy } from '@/types/api'

const MEMORY_SEARCH_KEYS = {
  all: ['memory-search'] as const,
  query: (
    workspaceId: string,
    query: string,
    strategy: SearchStrategy,
    limit: number,
    sourceType?: SearchRequest['sourceType']
  ) => [...MEMORY_SEARCH_KEYS.all, workspaceId, query, strategy, limit, sourceType ?? 'all-sources'] as const,
}

interface UseMemorySearchOptions {
  workspaceId: string
  query: string
  strategy?: SearchStrategy
  limit?: number
  sourceType?: SearchRequest['sourceType']
}

export function useMemorySearch(options: UseMemorySearchOptions) {
  const workspaceId = options.workspaceId.trim()
  const query = options.query.trim()
  const strategy = options.strategy ?? 'hybrid'
  const limit = options.limit ?? 20
  const sourceType = options.sourceType

  return useQuery<SearchResponse>({
    queryKey: MEMORY_SEARCH_KEYS.query(workspaceId, query, strategy, limit, sourceType),
    queryFn: () =>
      getApiClient().search({
        workspaceId,
        query,
        strategy,
        limit,
        ...(sourceType ? { sourceType } : {}),
      }),
    enabled: workspaceId.length > 0 && query.length > 0,
    staleTime: 1000 * 30,
  })
}
